export const questions = [
    {
        id:1,
        question:'What Is Blood Buddles?',
        answer:'Blood Buddles is a non-profit organization that helps people find and donate blood. We make it easy to find blood drives and to sign up to donate.',
    },
    {
        id:2,
        question:'Who can donate blood?',
        answer:'Most healthy adults between the ages of 18 and 65 can donate blood. There are a few restrictions, such as weight requirements and certain medical conditions. You can check your eligibility on our website.',
    },
    {
        id:3,
        question:'Is blood donation safe?',
        answer:'Yes, blood donation is very safe. We use sterile equipment and follow strict safety procedures. Our blood donors are also screened for bloodborne diseases.',
    },
    {
        id:4,
        question:'Does this website accept financial contributions?',
        answer:'We are not accepting donations, but we are always looking for volunteers. Your help is appreciated!',
    },
    {
        id:5,
        question:'Does blood donation hurt?',
        answer:'You may feel a slight pinch when the needle is inserted, but most people find blood donation to be painless. The entire process takes about 10-15 minutes.',
    },
]